<!-- Componente referente ao Reg Type -> Reg Selecionado -> Formulário -->

<template>
	<div>
		<v-dialog v-model="dialog" fullscreen persistent>
			<v-toolbar top dark color="primary" bottom>
				<v-btn icon @click="cancel" dark>
					<v-icon>mdi-arrow-left</v-icon>
				</v-btn>
				<v-toolbar-title class="ml-5" color="primary">{{
					value.description
				}}</v-toolbar-title>
				<v-spacer />
				<v-toolbar-items>
					<v-btn icon @click="confirm" dark :loading="loading">
						<v-icon>mdi-check</v-icon>
					</v-btn>
				</v-toolbar-items>
			</v-toolbar>

			<v-content style="background-color: white; height: 100%">
				<div style="background-color: white">
					<alert-box
						class="ma-5"
						v-model="alert.alerts"
						:type="alert.type"
					></alert-box>

					<datetime-picker-dialog
						v-if="value.allowRetroactive"
						ref="dateRetroactiveInput"
						classAttr="pa-10"
						outlined
						width="30%"
						dateFormat="dd/MM/yy"
						:label="$tc('entities.reg.props.date', 2)"
						v-model="dateRetroactive"
						@input="($event) => $emit('date-retroactive', $event)"
					></datetime-picker-dialog>

					<div v-if="value.regTypeFields && value.regTypeFields.length > 0">
						<div v-for="(item, i) in regTypeFieldsSortSeq" :key="i">
							<regTypeAutoFormField
								@enter="checkEnter(item.id)"
								:ref="item.id"
								:value="item"
								:variables="variables"
								:jobStage="jobStage"
								:continuous="isContinuous(item.id)"
							></regTypeAutoFormField>
						</div>
					</div>
				</div>
				<div></div>
				<v-spacer />
				<v-layout>
					<div></div>
					<v-spacer />
					<v-btn
						:loading="loading"
						class="ma-5"
						color="primary"
						dark
						bottom
						right
						fab
						@click="confirm"
					>
						<v-icon>mdi-check</v-icon>
					</v-btn>
				</v-layout>
			</v-content>
		</v-dialog>
	</div>
</template>

<script>
	import regTypeAutoFormField from "./regTypeAutoFormField";

	export default {
		components: { regTypeAutoFormField },
		props: {
			value: {},
			jobStage: {},
			variables: []
		},
		data() {
			return {
				dialog: false,
				alert: { alerts: [], type: "error" },
				loading: false,
				dateRetroactive: null,
			};
		},
		watch: {
			dialog(value) {
				console.log("VARIABLES >>> ", this.variables)
				if (value == false) {
					this.clear();
				}
			},
			value() {
				this.alert.alerts.length = [];
			},
		},
		computed: {
			regTypeFieldsSortSeq() {
				let regTypeFields = this.value.regTypeFields;
				return regTypeFields.sort((a, b) => {
					if (a.seq > b.seq) return 1;
					else if (a.seq < b.seq) return -1;
					else return 0;
				});
			},
		},
	methods: {
			// Caso o campo seja continuo e seja necessário guardar o valor para exibir novamente, é utlizado este método. 
			// Realiza um POST para o backend e guarda o valor em memória.
			postValueVariable() {
				if (
					this.value?.regTypeFields[0]?.variableKey != null &&
					this.value.continuous == true
				) {
					this.$emit("postValueVariable");
				}
			},

			clear() {
				this.$root.$emit("clean");
				this.$emit("date-retroactive", null);
				this.dateRetroactive = null;
				this.$refs.dateRetroactiveInput?.clearHandler();
				this.focusTop();
			},
			focusTop() {
				let idsFields = Object.getOwnPropertyNames(this.$refs);
				let isFocused = false;
				idsFields.forEach((fieldId) => {
					let ref = this.$refs[fieldId][0];

					if (ref && ref.valueIsNull()) {
						ref.focus();
						isFocused = true;
						return;
					}
				});

				if (!isFocused) {
					let firstField = this.$refs[idsFields[0]][0];
					if (firstField) firstField.focus();
				}
			},

			// Se o campo for do tipo continuo.
			isContinuous(regTypeFieldId) {
				return (
					this.value?.keepFieldIds &&
					this.value?.keepFieldIds.filter((rtf) => rtf == regTypeFieldId)
						.length > 0
				);
		},
			
			checkEnter(idField) {
				// TO DO: Melhorias
				// var keepfields = this.value.keepFieldIds;
				// for (let i = 0; i < keepfields.length; i++) {
				// 	console.log("aa", this.$refs[keepfields[i]][0].model.value);
				// }

				// Valida se é o último campo, se for, ao pressionar enter deve acionar o botão de confirmação do registro.
				let lastElement = this.value.regTypeFields.at(-1); 
				if (lastElement.id == idField) {
					this.confirm();
				}

				let idsFields = Object.getOwnPropertyNames(this.$refs);
				let actualField = this.$refs[idField][0];
				let aggregateValueIsFocused = actualField.aggregateValueIsFocused();
				console.log(aggregateValueIsFocused);
				let indexOf = idsFields.indexOf(idField);
				let nextId = idsFields[indexOf + 1];

				if (!nextId && !aggregateValueIsFocused) return;
				let field = aggregateValueIsFocused
					? actualField
					: this.$refs[nextId][0];
				if (field != null) field.focus();
			},
			loadingConfirm() {
				this.loading = !this.loading;
			},
			addAlert(error) {
				this.alert.alerts.push(error);
			},
			open() {
				this.dialog = !this.dialog;
			},
			isOpen() {
				return this.dialog;
			},
			requiredValidation() {},
			errorNotificationRequired(label) {
				this.alert.alerts.push(`${label} is Required`);
			},
			cancel() {
				this.$emit("close");
				this.dialog = false;
			},
			fieldIsRequiredValidate(regType) {
				let regField = this.$refs[regType.id][0].getValue();

				if (regType.isRequired) {
					console.log(JSON.stringify(regField));
					if (!regField.value || regField.value == "") {
						this.errorNotificationRequired(regField.field);
						return false;
					}

					if (
						(regType.behavior == 0 || regType.behavior == 2) &&
						(!regField.aggregateValue || regField.aggregateValue == "")
					) {
						this.errorNotificationRequired(`${regField.field} OPTION`);
						return false;
					}
				}
				return true;
			},

			// Confirma a inserção do registro.
			confirm() {
				this.alert.alerts = [];
				let regFields = [];

				this.postValueVariable();

				this.value.regTypeFields.forEach((rt) => {
					let regField = this.$refs[rt.id][0].getValue();
					if (this.fieldIsRequiredValidate(rt)) regFields.push(regField);
				});

				if (this.alert.alerts.length > 0) return;
				this.$emit("confirm", regFields);
			},
		},
	};
</script>
